export const PEP_TOOLTIP_CATEGORIES: Array<{ label: string; description: string }> = [
  {
    label: "Category 1",
    description:
      "Private individuals or private companies beneficially owned or controlled by a PEP or having a nexus to a PEP, such as a single-member LLC where the sole member holds a government position.",
  },
  {
    label: "Category 2",
    description:
      "Financial institutions, registered charities, and other non-profit entities with a form of PEP nexus, like a public charity where one of the board members is a former senator.",
  },
  {
    label: "Category 3",
    description:
      "State-owned entities, such as government-controlled or associated entities and Sovereign Wealth Funds, for example, the Los Angeles County Employment Retirement Association (LACERA), which manages the retirement fund for employees of Los Angeles County.",
  },
  {
    label: "N/A",
    description: "No PEP exposure identified",
  },
];
